import React from 'react'
import { Permission, PermissionTreeNode, isPermissionVisible } from '../utils'
import { PermissionTreeItem } from './PermissionTreeItem'

interface PermissionGroupProps {
  groupName: string
  permissionTree: PermissionTreeNode[]
  permissions: Permission[]
  getPermissionValue: (id: number) => boolean | string | null
  onCheckboxChange: (e: any) => void
  onSelectChange: (value: string | null, id: number) => void
}

export const PermissionGroup: React.FC<PermissionGroupProps> = ({
  groupName,
  permissionTree,
  permissions,
  getPermissionValue,
  onCheckboxChange,
  onSelectChange,
}) => {
  // Рекурсивная функция для отображения дерева прав
  const renderPermissionTree = (nodes: PermissionTreeNode[], level = 0): React.ReactNode => {
    return nodes.map(node => {
      const visible = isPermissionVisible(node, permissions, getPermissionValue)
      const currentValue = getPermissionValue(node.id)

      return (
        <PermissionTreeItem
          key={node.id}
          node={node}
          level={level}
          currentValue={currentValue}
          onCheckboxChange={onCheckboxChange}
          onSelectChange={onSelectChange}
          isVisible={visible}
        >
          {node.children.length > 0 && renderPermissionTree(node.children, level + 1)}
        </PermissionTreeItem>
      )
    })
  }

  return (
    <div style={{ marginBottom: 24 }}>
      <h3
        style={{
          margin: '0 0 16px 0',
          paddingBottom: '8px',
          borderBottom: '1px solid #d9d9d9',
          fontSize: '16px',
          fontWeight: 600,
        }}
      >
        {groupName}
      </h3>
      <div
        style={{
          padding: '16px',
          borderRadius: '6px',
        }}
      >
        {renderPermissionTree(permissionTree)}
      </div>
    </div>
  )
}
